import { createFileRoute } from "@tanstack/react-router";
import { LancamentoDetalhePage } from "@/pages/LancamentoDetalhePage";

export const Route = createFileRoute("/lancamentos/$id")({
  head: () => ({ meta: [{ title: "Lançamento — AXIS Comprovantes" }] }),
  component: LancamentoDetalhePage,
});
